export default "__VITE_ASSET__BNlp20me__"